// extracted by mini-css-extract-plugin
export default {"empty":"notificationList_empty__WhDin"};